export const popupKeyData = {
  SOFTWARE: 'software', //软件中心
  CONVERSION: 'conversion', //经纬度转换
  TERRAIN: 'terrain', //地形处理
  TERRAIN_IMAGE: 'terrainImage', //地形处理-图片
  MAP: 'map', //地图处理
  AERSCREEN: 'aerscreen', //AERSCREEN
  FEEDBACK: 'feedback', //问题反馈
  MESSAGE: 'message', //消息管理
  DOWNLOAD: 'download' //下载管理
}

/** 所有弹窗 key 的数组，用于批量操作（如路由离开时清理）。 */
export const allPopupKeys = Object.keys(popupKeyData)

export const maxName = (key) => `${popupKeyData[key]}Visible`
export const minName = (key) => `${popupKeyData[key]}MinVisible`

/**
 * 从 Vuex store.state 读取弹窗可见性。
 * @param {import('vuex').Store} store
 * @param {string} key - popupKeyData 中的 key，如 'MAP'
 * @param {'max'|'min'} [type='max']
 * @returns {boolean}
 */
export function getPopupVisible(store, key, type = 'max') {
  const stateKey = type === 'min' ? minName(key) : maxName(key)
  return store.state[stateKey]
}
